import type { Link } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSLink } from '@swf/cms';

import styles from './CMSHeaderLink.scss';

const CMSHeaderLink: React.FC<{ header_link: Link }> = ({ header_link: headerLink }) => (
  <CMSLink {...headerLink} className={styles.headerLink} />
);

export default CMSHeaderLink;
